module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUCAIAAABj86gYAAAAsElEQVRIx2O4JGCCH+2QNmfI8iMf0duCOy6JVxWcaGjBu8Ubn1X2Ut+CG4YBtx1ib9lG/X755vulm0DGHef46xqeQKnr6nr/zzGQjaAWAIPly/Hz/37/+Q8G/378/Lj1wGUxS6pZAEEft+yHWPCydx5ckJoW/Hzw9Mfth79fvv1y7Bz1Lbiu4/N23ppLQmaXxa3eLd8CJIdmPhiCFlASgURF8qgFBC2gKAKJQaMWEEIAsYsDkOhbzp8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/tg.png
// module id = 937
// module chunks = 0